/* Import Packages */
import Vue from 'vue';
import Router from 'vue-router';

/* Initialize Vue Router */
Vue.use(Router);

/* Set Guards */
const requiresAuth = true;
//const requiresAdmin = true;

/* Import Layouts */
import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';

/* Define Routes */
export default new Router({
	mode: 'history',
	linkExactActiveClass: 'active',
	scrollBehavior (to, from, savedPosition) {
		return to.hash ? { selector: to.hash } : ( savedPosition ? savedPosition : { x: 0, y: 0 } )
	},
	routes: [
		{
			path: '/',
			component: MainLayout,
			children: [
				{
					path: '/',
					component: () => import('@/views/QuestionView'),
					meta: {
						page: {
							title: 'Daily Question'
						}
					}
				},
				{
					path: '/q/:qid',
					component: () => import('@/views/QuestionView'),
					meta: {
						page: {
							title: 'Daily Question'
						}
					}
				},
				{
					path: 'dashboard',
					meta: {
						requiresAuth,
						page: {
							title: 'Dashboard'
						}
					},
					component: () => import('@/views/DashboardView')
				},
				{
					path: 'privacy',
					meta: {
						page: {
							title: 'Privacy Policy'
						}
					},
					component: () => import('@/views/PrivacyView')
				}
			]
		},
		{
			path: '/',
			component: AuthLayout,
			children: [
				{
					path: 'sign-in',
					component: () => import('@/views/SignInView')
				},
				{
					path: 'sign-up',
					component: () => import('@/views/SignUpView')
				},
				{
					path: 'unsubscribe',
					component: () => import('@/views/UnsubscribeView')
				}
			]
		}
	]
});
